const formatSoftSkills = (softSkills, translateFn) =>
  softSkills.map(softSkill => ({
    skill: translateFn(`SOFT_SKILLS_LABELS_${softSkill?.name}`) ?? softSkill?.name ?? '',
    value: softSkill?.value ?? 0,
    isFeatured: softSkill?.isFeatured,
  }));

export default formatSoftSkills;
